module.exports = __webpack_public_path__ + "static/media/storie_01.d47af8da.jpg";